import { CalcIcon } from "./CalcIcon";
import "./navigation.css";

export function SubNavCalculadora({ tela, onIrCalculadora, onIrOrcamentos, onIrHistorico, onIrInicio }) {
  const itens = [
    ["calculadora", "Calculadora", "calculator", onIrCalculadora],
    ["orcamentos", "Orçamentos", "receipt", onIrOrcamentos],
    ["historico", "Histórico", "history", onIrHistorico],
  ];

  return (
    <nav className="calc-subnav" data-tour="calc-navegacao" aria-label="Navegação da calculadora">
      {onIrInicio && (
        <button type="button" className="calc-subnav-home" onClick={onIrInicio}
          aria-label="Início da calculadora" title="Início da calculadora">
          <CalcIcon name="home" size={18} />
        </button>
      )}
      <div className="calc-subnav-tabs">
        {itens.map(([id, label, icon, onClick]) => (
          <button type="button" key={id} onClick={onClick}
            className={`calc-subnav-tab${tela === id ? " is-active" : ""}`}
            aria-current={tela === id ? "page" : undefined}>
            <CalcIcon name={icon} size={17} />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
